import api from './api';

// ==================== STOCK PRINCIPAL (Secrétaire/Vétérinaire) ====================
export const stockAPI = {
  // Récupérer le stock principal
  getStockPrincipal: () => api.get('/stock/principal'),
  
  // Détail d'un produit
  getDetailProduit: (id) => api.get(`/stock/principal/${id}`),
  
  // Entrée de stock
  ajouterStock: (data) => api.post('/stock/entree', data),
  
  // Sortie de stock
  retirerStock: (data) => api.post('/stock/sortie', data),
  
  // Modifier seuil d'alerte
  updateSeuil: (id, data) => api.put(`/stock/seuil/${id}`, data),
  
  // Statistiques
  getStatistiques: () => api.get('/stock/principal/statistiques'),
};

// ==================== ALERTES ====================
export const alertesAPI = {
  // Liste des alertes
  getAlertes: (params) => api.get('/stock/alertes', { params }),
  
  // Compter alertes non lues
  countNonLues: () => api.get('/stock/alertes/count'),
  
  // Marquer comme lue
  marquerLue: (id) => api.put(`/stock/alertes/${id}/lire`),
  
  // Marquer tout comme lu
  marquerToutLu: () => api.put('/stock/alertes/lire-tout'),
  
  // Notifications
  getNotifications: (params) => api.get('/stock/notifications', { params }),
  
  // Marquer notification lue
  marquerNotificationLue: (id) => api.put(`/stock/notifications/${id}/lire`),
};

// ==================== TRANSFERTS ====================
export const transfertsAPI = {
  // Demander un transfert
  demanderTransfert: (data) => api.post('/stock/transferts/demander', data),
  
  // Valider un transfert
  validerTransfert: (id, data) => api.put(`/stock/transferts/${id}/valider`, data),
  
  // Annuler un transfert
  annulerTransfert: (id) => api.put(`/stock/transferts/${id}/annuler`),
  
  // Transferts en attente
  getEnAttente: () => api.get('/stock/transferts/en-attente'),
  
  // Historique
  getHistorique: (params) => api.get('/stock/transferts/historique', { params }),
};

// ==================== STOCK TECHNICIEN ====================
export const stockTechnicienAPI = {
  // Mon stock
  getMonStock: () => api.get('/stock/technicien/mon-stock'),
  
  // Info de mon stock
  getInfo: () => api.get('/stock/technicien/info'),
  
  // Sortie de stock
  sortieStock: (data) => api.post('/stock/technicien/sortie', data),
  
  // Modifier mon seuil
  updateMonSeuil: (id, data) => api.put(`/stock/technicien/seuil/${id}`, data),
  
  // Mes alertes
  getMesAlertes: (params) => api.get('/stock/technicien/mes-alertes', { params }),
  
  // Mon historique
  getMonHistorique: (params) => api.get('/stock/technicien/historique', { params }),
  
  // Stock principal (pour demander transfert)
  getStockPrincipal: () => api.get('/stock/technicien/stock-principal'),
};

// ==================== STOCK VÉTÉRINAIRE ====================
export const stockVeterinaireAPI = {
  // Tous les stocks
  getTousLesStocks: () => api.get('/stock/veterinaire/tous-les-stocks'),
  
  // Statistiques globales
  getStatistiquesGlobales: () => api.get('/stock/veterinaire/statistiques-globales'),
  
  // Stock d'un technicien
  getStockTechnicien: (id) => api.get(`/stock/veterinaire/technicien/${id}`),
  
  // Toutes les alertes
  getToutesAlertes: (params) => api.get('/stock/veterinaire/toutes-alertes', { params }),
  
  // Tous les transferts
  getTousTransferts: (params) => api.get('/stock/veterinaire/tous-transferts', { params }),
  
  // Historique complet
  getHistoriqueComplet: (params) => api.get('/stock/veterinaire/historique-complet', { params }),
  
  // Rapport de consommation
  getRapportConsommation: (params) => api.get('/stock/veterinaire/rapport-consommation', { params }),
  
  // Créer stock technicien
  creerStockTechnicien: (data) => api.post('/stock/veterinaire/creer-stock-technicien', data),
};
